/**
 * AppTopbar.jsx — Phase 2 App Shell + Jul 2026 Theme Refresh
 *
 * Sticky top bar sitting above every DashboardLayout page.
 * Renders:
 *   • Mobile hamburger (md:hidden)
 *   • Breadcrumb / page-level header slot (`children`)
 *   • Right-side action icons (notification bell, user avatar, theme toggle)
 *
 * Tokens-first: bg-white / bg-background (dark), border-border, etc.
 */

import React from 'react';
import { PanelLeftOpen, Menu } from 'lucide-react';

export default function AppTopbar({
  onMobileMenuOpen = () => {},
  children,
}) {
  return (
    <header className="sticky top-0 z-30 flex h-14 items-center gap-3 border-b border-border bg-white/80 dark:bg-background/80 backdrop-blur-sm px-4 md:px-6">
      {/* Mobile-only hamburger */}
      <button
        type="button"
        aria-label="Open sidebar"
        onClick={onMobileMenuOpen}
        className="md:hidden p-1.5 rounded-md text-foreground-muted hover:bg-accent"
        data-testid="topbar-mobile-menu"
      >
        <Menu className="h-5 w-5" />
      </button>

      {/* Right-aligned actions slot: company switcher, notification bell,
          profile menu are passed in as children from DashboardLayout.
          B1 fix (Jul 2026): Added flex + justify-end so children render
          in a horizontal row at the far right of the topbar instead of
          stacking as block elements. */}
      <div className="flex-1 min-w-0 flex items-center justify-end gap-1">{children}</div>
    </header>
  );
}
